import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 6h10","key":"svg-0"}],["path",{"d":"M4 12h16","key":"svg-1"}],["path",{"d":"M7 12h13","key":"svg-2"}],["path",{"d":"M7 18h10","key":"svg-3"}]]

const IconMenu4 = createReactComponent('outline', 'menu-4', 'Menu4', __iconNode);

export default IconMenu4;